(function () {
  'use strict';

  var section = document.querySelector('[data-home-featured-beans]');
  if (!section) return;
  if (section.getAttribute('data-live-roasts') !== 'true') return;

  var endpoint = section.getAttribute('data-live-endpoint');
  if (!endpoint) return;

  var grid = section.querySelector('.home-featured-beans__grid');
  if (!grid) return;

  var anonKey = section.getAttribute('data-supabase-anon-key') || '';
  var maxProducts = parseInt(section.getAttribute('data-max-products') || '6', 10);
  var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';
  var fallbackHtml = grid.innerHTML;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    if (moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return '$' + amount;
  }

  function formatPrice(product) {
    if (product.price_varies) {
      return 'From ' + formatMoney(product.price_min);
    }
    return formatMoney(product.price);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () {
      return null;
    });
  }

  function buildCard(product, meta, index) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var soldOut = !product.available;
    var badgeHtml = '';

    if (meta && meta.roasted_label) {
      badgeHtml += '<span class="home-bean-card__badge home-bean-card__badge--roasted">' + escapeHtml(meta.roasted_label) + '</span>';
    } else if (soldOut) {
      badgeHtml += '<span class="home-bean-card__badge home-bean-card__badge--sold-out">Sold out</span>';
    }

    var ratio = '100%';
    var imgHtml = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="533" height="533">'
      : '';

    return (
      '<li class="home-bean-card home-featured-beans__item" style="--hfb-delay: ' + (index * 80) + 'ms;" data-product-handle="' + escapeHtml(product.handle) + '">' +
        '<div class="home-bean-card__stack">' +
          '<div class="card-wrapper underline-links-hover">' +
            '<div class="card card--standard card--media card--extend-height" style="--ratio-percent: ' + ratio + ';">' +
              '<div class="card__inner ratio" style="--ratio-percent: ' + ratio + ';">' +
                (imgHtml
                  ? '<div class="card__media"><div class="media media--transparent media--hover-effect">' + imgHtml + '</div></div>'
                  : '') +
                '<div class="card__content">' +
                  '<div class="card__information">' +
                    '<h3 class="card__heading"><a href="' + escapeHtml(product.url) + '" class="full-unstyled-link">' + escapeHtml(product.title) + '</a></h3>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="card__content">' +
                '<div class="card__information">' +
                  '<h3 class="card__heading h5"><a href="' + escapeHtml(product.url) + '" class="full-unstyled-link">' + escapeHtml(product.title) + '</a></h3>' +
                  '<div class="card-information">' +
                    '<div class="price"><div class="price__container">' +
                      '<div class="price__regular"><span class="price-item price-item--regular">' + escapeHtml(formatPrice(product)) + '</span></div>' +
                    '</div></div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          (badgeHtml
            ? '<div class="home-bean-card__layer" style="--hbc-overlay-ratio: 1 / 1;">' + badgeHtml + '</div>'
            : '') +
        '</div>' +
      '</li>'
    );
  }

  function renderLiveCards(beans) {
    if (!beans || !beans.length) return false;

    return Promise.all(
      beans.slice(0, maxProducts).map(function (bean, index) {
        return fetchProduct(bean.handle).then(function (product) {
          if (!product) return '';
          return buildCard(product, bean, index);
        });
      }),
    ).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      if (!html) return false;
      grid.innerHTML = html;
      section.classList.add('home-featured-beans--live');
      section.classList.add('is-visible');
      return true;
    });
  }

  function fetchLive() {
    var headers = { Accept: 'application/json' };
    if (anonKey) {
      headers.Authorization = 'Bearer ' + anonKey;
      headers.apikey = anonKey;
    }

    fetch(endpoint, { headers })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.featured_beans)) return;
        return renderLiveCards(data.featured_beans);
      })
      .catch(function () {});
  }

  grid.setAttribute('data-fallback-html-stored', 'true');
  fetchLive();
})();
